import { MenuItem, TextField, Typography } from '@mui/material';
import React from "react";
import { StyleLine } from '../../../types';

export default function SelectDefaultEdgeShape(props) {

  const HandleStyleEdgeChange = (type) => {
    props.handleChange({
      target: {
        name: "defaultedgetype",
        value: type.target.value
      }
    });
  }

  return (
    <div>
      {props.hideLabel != true &&
        <Typography variant="caption">
          Default style preferences for edges.
        </Typography>
      }
      <TextField 
        id="template-style-shape" 
        select 
        label="Edge style" 
        size="small" 
        margin="dense" 
        defaultValue={props.defaultValue} 
        value={props.value} 
        onChange={HandleStyleEdgeChange} 
        sx={{ width: "100%" }}>
        {StyleLine.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
}